// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"8f34aae7fad885dd8d3e","655":"a697223a4c490cfe532b"}[chunkId] + ".js";
};